// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/landmark-regain-track.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/landmark-regain-track/angle-regain-track.js';
import g1 from '../lessons/navigation/landmark-regain-track/landmark-regain-track.js';

mount([g0, g1]);
